// extracted by mini-css-extract-plugin
export var final = "FourthStep-module--final--DBa5z";
export var muted_text = "FourthStep-module--muted_text--NVVqC";
export var text = "FourthStep-module--text--2T3LC";
export var text_container = "FourthStep-module--text_container--1FAXY";
export var titleContainerFinal = "FourthStep-module--titleContainerFinal--b3-h2";
export var titleInFinalContainer = "FourthStep-module--titleInFinalContainer--ZpjPK";